import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import { useTranslationMipCreate } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { memo, useMemo } from 'react';
import styled from 'styled-components';

interface Props {
	className?: string;
}

const FirstTabContent = ({ className }: Props) => {
	const tMipCreate = useTranslationMipCreate();

	const listItems = useMemo(
		() => [
			tMipCreate('help_modal.tabs.tab_1.list.item_1'),
			tMipCreate('help_modal.tabs.tab_1.list.item_2'),
			tMipCreate('help_modal.tabs.tab_1.list.item_3'),
		],
		[]
	);

	return (
		<div className={className}>
			<ul>
				{listItems.map((text) => (
					<li key={text}>
						<Text colorFaded variant="p-lg">
							{text}
						</Text>
					</li>
				))}
			</ul>

			<Text colorFaded variant="p-lg">
				{tMipCreate('help_modal.tabs.tab_1.text')}
			</Text>
		</div>
	);
};

const Memoized = memo(FirstTabContent);
const Styled = styled(Memoized)`
	white-space: pre-line;
	ul {
		list-style-type: disc;
		margin-left: 1.5em;
	}

	& > ${Text}:last-of-type {
		margin-top: 1rem;
	}
`;

export { Styled as FirstTabContent };
